import {cn} from 'platform/shared-tw';

import {
  createKeyDownHandler,
  partFill,
  partStroke,
  type DiagramVariant,
} from '../shared/partVariants';

interface AirCoolingSystemProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function AirCoolingSystem(props: AirCoolingSystemProps) {
  return (
    <svg
      width="77"
      height="436"
      viewBox="0 0 77 436"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute focus:outline-none focus-visible:outline-none [pointer-events:none] cursor-pointer group"
      style={{top: 33, left: 317}}
      onClick={props.onClick}
      onKeyDown={createKeyDownHandler(props.onClick)}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
    >
      <path
        d="M41 251C41 335.8 63.6667 401.333 75 423C70.3428 428.174 64.6914 431.999 58.881 434.793C43.8787 408.583 21 329.934 21 305C21 285 1 289 1 268L1 218L1 168C1 147 21 151 21 131C21 106.066 43.8787 27.4169 58.881 1.2071C58.881 1.2071 58.881 1.20709 58.881 1.20709L58.8846 1.20086C58.9231 1.13356 58.9616 1.06661 59 1L58.8846 1.20086C58.8834 1.20294 58.8822 1.20502 58.881 1.2071C64.6915 4.0005 70.3428 7.8255 75 13.0001C63.6667 34.6668 41 100.2 41 185L41 218V251Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M41 218V251C41 335.8 63.6667 401.333 75 423C70.3428 428.174 64.6914 431.999 58.881 434.793L59 435C44 409 21 330 21 305C21 285 1 289 1 268L1 218L1 168C1 147 21 151 21 131C21 106 44 27 59 1L58.881 1.20709C64.6914 4.0005 70.3428 7.8255 75 13.0001C63.6667 34.6668 41 100.2 41 185L41 218Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        x="11"
        y="158"
        width="20"
        height="50"
        rx="10"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></rect>
      <rect
        x="11"
        y="158"
        width="20"
        height="50"
        rx="10"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M19 208C19 188.461 19 177.473 19 158"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15.0001 206C15 188.105 15 177.897 15 160"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M23 208C23 188.462 23 177.476 23 158"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M11 183C25.3776 183 16.6678 183 30.9999 183"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M11 199C25.3776 199 16.6678 199 30.9999 199"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M11 167C25.3776 167 16.6678 167 30.9999 167"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M27.0001 206L27.0001 160.002"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="11"
        y="228"
        width="20"
        height="50"
        rx="10"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></rect>
      <rect
        x="11"
        y="228"
        width="20"
        height="50"
        rx="10"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M19 278C19 258.461 19 247.473 19 228"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15.0001 276C15 258.105 15 247.897 15 230"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M23 278C23 258.462 23 247.476 23 228"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M11 253C25.3776 253 16.6678 253 30.9999 253"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M11 269C25.3776 269 16.6678 269 30.9999 269"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M11 237C25.3776 237 16.6678 237 30.9999 237"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M27.0001 276L27.0001 230.002"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
